export default class CashFlowModel {
  constructor() {
    this.bankId = '';
    this.type = 0;
    // 銀行
    this.targetTitle = '';
    // 分行
    this.targetSubTitle = '';
    // 人員
    this.targetName = '';
    // 帳戶
    this.targetAccount = '';
    // 結餘
    this.agentId = '';
    this.transactionDate = '';
    this.price = 0;
    this.comment = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/CashFlowModel.js